import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';

interface SavedFilterFormProps {
  onSave: (name: string) => string | null;
  onSuccess?: () => void;
  onCancel?: () => void;
  initialValue?: string;
  title?: string;
}

export const SavedFilterForm = ({
  onSave,
  onSuccess,
  onCancel,
  initialValue = '',
  title,
}: SavedFilterFormProps) => {
  const { t } = useTranslation();
  const displayTitle = title ?? t('brain_logs.save_filter_view');

  const form = useForm({ defaultValues: { name: initialValue } });

  const handleSubmit = form.handleSubmit(({ name }) => {
    const error = onSave(name);
    if (error) {
      form.setError('name', { message: error });
    } else {
      onSuccess?.();
    }
  });

  return (
    <div className="flex w-80 flex-col items-start justify-start gap-4 px-4 pt-4 pb-5">
      <p className="text-base leading-none font-medium">{displayTitle}</p>

      <Form {...form}>
        <form onSubmit={handleSubmit} className="w-full space-y-4">
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{t('common.name')}</FormLabel>
                <FormControl>
                  <Input autoFocus {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <div className="flex w-full flex-row-reverse justify-start gap-2">
            <Button type="submit" size="md">
              {t('common.save')}
            </Button>
            <Button type="button" variant="ghost-neutral" size="md" onClick={onCancel}>
              {t('common.cancel')}
            </Button>
          </div>
        </form>
      </Form>
    </div>
  );
};
